import {UserTypes} from '../constants/Constants';

export interface IServerUserReponse {
   Id: string;
   IsUserDeleted: boolean;
   UserType: UserTypes.techSmith | UserTypes.selfIdentified;
   DisplayName: string;
   ProfileImageUrl: string;
   EmailAddress: string;
}

export const nullServerUserFactory = (initialData?: Partial<IServerUserReponse>): IServerUserReponse => Object.assign({
   Id: '',
   IsUserDeleted: false,
   UserType: UserTypes.techSmith,
   DisplayName: '',
   ProfileImageUrl: '',
   EmailAddress: ''
}, initialData);
